import { usePathMatchIndex } from '@features/auth/hooks';
import { AuthStepper } from '@features/auth/registration/components/Common/AuthStepper';
import { useAppbarTitle } from '@hooks/useAppbarTitle';
import { usePageTitle } from '@hooks/usePageTitle';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const steps = ['search', 'description', 'review-and-send'];

export function SpecialistRequestLayout() {
	const { t } = useTranslation();
	const location = useLocation();

	usePageTitle(t('services'));
	useAppbarTitle(location.pathname.includes('express') ? t('express') : t('oneTime'));

	const activeStepIndex = usePathMatchIndex(steps);
	return <AuthStepper hFull activeStepIndex={activeStepIndex} steps={steps} />;
}
